export const PREPARE_TEXT =
  "Prepare your answer to the following question. The video will automatically start when the timer ends.";
export const ANSWER_TEXT = "Begin your answer.";
export const QUESTION_PLACEHOLDER = "Question will appear here";
export const UPLOAD_TEXT = "Review and upload your video.";
